import React from 'react'

type BetaPricingProps = {
  onSubscribe?: () => void
}

export default function BetaPricing({ onSubscribe }: BetaPricingProps) {
  return (
    <section className="bg-neutral-950 py-16 sm:py-20">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-semibold tracking-tight text-white sm:text-4xl">
            Founding Member Beta — $20/month
          </h2>
          <p className="mt-3 text-neutral-300">
            Your support funds active development and faster improvements. You get
            everything we build during beta. Price locked for life.
          </p>
        </div>

        <div className="mx-auto mt-10 grid max-w-4xl grid-cols-1 gap-6 sm:mt-12 lg:grid-cols-3">
          {/* Empty columns for balance on large screens */}
          <div className="hidden lg:block" />
          <div className="rounded-2xl border border-neutral-800 bg-neutral-900/40 p-6 shadow-2xl lg:col-span-1">
            <div className="flex items-baseline justify-between">
              <h3 className="text-lg font-medium text-white">All-In (Beta)</h3>
              <span className="rounded-full bg-neutral-800 px-3 py-1 text-xs font-medium text-neutral-300 ring-1 ring-inset ring-neutral-700">
                Price locked for life
              </span>
            </div>

            <div className="mt-4 flex items-end gap-1">
              <span className="text-4xl font-semibold text-white">$20</span>
              <span className="pb-1 text-sm text-neutral-400">/month</span>
            </div>

            <ul className="mt-6 space-y-3 text-sm text-neutral-200">
              <li className="flex gap-2">
                <span aria-hidden className="mt-2 h-1.5 w-1.5 rounded-full bg-white" />
                Unlimited weekly meal plans
              </li>
              <li className="flex gap-2">
                <span aria-hidden className="mt-2 h-1.5 w-1.5 rounded-full bg-white" />
                Smart shopping lists
              </li>
              <li className="flex gap-2">
                <span aria-hidden className="mt-2 h-1.5 w-1.5 rounded-full bg-white" />
                Clean PDF exports
              </li>
              <li className="flex gap-2">
                <span aria-hidden className="mt-2 h-1.5 w-1.5 rounded-full bg-white" />
                Priority fixes &amp; updates
              </li>
              <li className="flex gap-2">
                <span aria-hidden className="mt-2 h-1.5 w-1.5 rounded-full bg-white" />
                Founding Member badge
              </li>
            </ul>

            <button
              onClick={onSubscribe}
              className="mt-6 w-full rounded-md bg-white px-4 py-3 text-sm font-semibold text-neutral-900 shadow-sm hover:bg-neutral-200 focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
            >
              Start for $20/month
            </button>

            <p className="mt-3 text-center text-xs text-neutral-400">
              Cancel anytime. No hidden tiers.
            </p>
          </div>
          <div className="hidden lg:block" />
        </div>

        <div className="mx-auto mt-12 max-w-3xl">
          <dl className="space-y-6">
            <div>
              <dt className="text-sm font-medium text-white">Is this meal prep?</dt>
              <dd className="mt-2 text-sm text-neutral-300">
                No—Nura is <span className="font-medium text-white">meal planning</span> software.
                We help you decide what to cook and shop for, fast.
              </dd>
            </div>
            <div>
              <dt className="text-sm font-medium text-white">Will my price increase later?</dt>
              <dd className="mt-2 text-sm text-neutral-300">
                No. Founding Member pricing is locked for life.
              </dd>
            </div>
            <div>
              <dt className="text-sm font-medium text-white">Do I need anything special?</dt>
              <dd className="mt-2 text-sm text-neutral-300">
                Just a modern browser. PDFs open anywhere.
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </section>
  )
}